module.exports = __webpack_public_path__ + "img/main-bg.e6bbb977.png";